module.exports = __webpack_public_path__ + "img/Avatar-67.2d329ae5.svg";